export default __webpack_public_path__ + "static/media/HDTX_Annual Report 2023.c7bed4cf.pdf";